import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactGA from 'react-ga';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';

export class FlagVideo extends React.Component {
  static propTypes = {
    mediaId: PropTypes.string.isRequired,
    flagged: PropTypes.bool,
    playerPage: PropTypes.bool,
    className: PropTypes.string,
    onFlagVideo: PropTypes.func.isRequired
  }

  static defaultProps = {
    flagged: false,
    playerPage: false,
    className: 'viappbar__flagged'
  }

  state = {
    flaggedFromProps: false,
    flagged: false
  }

  handleToggle = () => {
    const {flagged} = this.state;
    this.setState({flagged: !flagged});
    this.props.onFlagVideo(this.props.mediaId, !flagged);

    const action = !flagged ? 'Flag Video' : 'Unflag Video';
    const label = this.props.playerPage ? 'Top Header' : 'Video Card';
    const category = this.props.playerPage ? 'Player' : 'Library';
    const trackInfo = {category, action, label};
    ReactGA.event(trackInfo);
  }

  render() {
    const {className} = this.props;
    const {flagged} = this.state;

    return (
      <IconButton onClick={this.handleToggle} id={`videoFlag-${this.props.mediaId}`}>
        <Icon className={classNames({
          className: !flagged,
          [`${className}-active`]: flagged
        })}>flag</Icon>
      </IconButton>
    );
  }

  static getDerivedStateFromProps(nextProps, currentState) {
    if (currentState.flaggedFromProps !== nextProps.flagged) {
      return {
        flaggedFromProps: nextProps.flagged,
        flagged: nextProps.flagged
      };
    }

    return {};
  }
}

export default FlagVideo;
